// extracted by mini-css-extract-plugin
module.exports = {"text":"SvgDeadEnd_text__3Lg8k"};